import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/index.vue'
import People from '@/pages/people/single.vue'
import Campaign from '@/pages/campaign/index.vue'
import Login from '@/pages/login/'

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    name: 'Login',
    path: '/login',
    component: Login,
    meta: {
      auth: false,
      title: 'Login Mala direta Trackmob'
    }
  },
  {
    name: 'Home',
    path: '/home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    name: 'campaign',
    path: '/campaign/:id',
    component: Campaign,
    meta: {
      auth: true
    }
  },
  {
    name: 'people.single',
    path: '/people/:id',
    component: People,
    meta: {
      auth: true
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
